<template>
  <PokerTableSkeleton
    :players="l_players"
    class="table-street-gmf-selektor tblgmfslctr"
    style="--cards-space: 0px"
    tableDirection="horizontal"
  >
    <template #any>
      <ChartLegendPlayers
        v-show="hasLegend"
        class="anim-fade-in"
        style="left: 0.75rem; top: 0.75rem"
        :oopPlayer="hasBig ? { position: $t('common.stack_big'), is_hero: false } : null"
        :ipPlayer="{ position: $t('common.stack_short'), is_hero: false }"
      >
        <!-- --clr-player_oop: var(--clr-player_stack-big);
          --clr-player_ip: var(--clr-player_stack-short); -->
        <template #icon_oop>
          <div
            class="mdi mdi-menu-up text-large f-center"
            style="
              color: var(--clr-player_stack-big);
              height: 1.2rem;
              width: 1.5rem;
              margin-left: -0.25rem;
            "
          ></div>
        </template>
        <template #icon_ip>
          <div
            class="mdi mdi-menu-down text-large f-center"
            style="
              color: var(--clr-player_stack-short);
              height: 1.2rem;
              width: 1.5rem;
              margin-left: -0.25rem;
            "
          ></div>
        </template>
      </ChartLegendPlayers>
    </template>
    <template
      v-for="player in l_players"
      #[player.position]
      :key="player.position"
    >
      <slot :name="`${player.position}_before`" />
      <PokerPlayer
        :player="player"
        :hasStack="true"
        :hasCards="false"
        :style="player.style"
      >
        <template #[player.position]>
          <slot :name="player.position" />
        </template>
      </PokerPlayer>
    </template>
  </PokerTableSkeleton>
</template>

<script>
import PokerTableSkeleton from '@/components/PokerTable/PokerTableSkeleton'
import ChartLegendPlayers from '@/components/Charts/LineCharts/ChartLegendPlayers'
import PokerPlayer from '@/components/PokerTable/PokerPlayer'
import { getPlayersDefault } from '@/store/gamestate/gamestate'

export default {
  name: 'PokerTableGmfSelektor',
  components: {
    PokerPlayer,
    ChartLegendPlayers,
    PokerTableSkeleton,
  },
  props: {
    gameformat: Object,
  },
  computed: {
    hasBig() {
      return this.gameformat.group !== 'spins'
    },
    l_players() {
      let res = getPlayersDefault({ gameformat: this.gameformat })
      const allStacks = res.map(p => p.stack)
      const min = Math.min(...allStacks)
      const max = Math.max(...allStacks)
      if (min !== max) {
        res = res.map(p => ({
          ...p,
          style:
            p.stack === min
              ? '--clr-player-stroke:var(--clr-player_stack-short)'
              : p.stack === max && this.hasBig
              ? '--clr-player-stroke:var(--clr-player_stack-big)'
              : '',
        }))
      }

      return res
    },
    hasLegend() {
      return this.l_players.some(p => p.style)
    },
  },
}
</script>
<style lang="scss" scoped>
.tblgmfslctr {
  position: relative;
}
</style>
